var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToolIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_3",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 430 430",
    style: {
      enableBackground: "new 0 0 430 430"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#000000;}\n\t.st1{fill:#000000;}\n\t.st2{fill:#000000;fill-opacity:0;}\n\t.st3{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M346.54,324.76c6.07,6.07,6.07,15.91,0,21.98c-6.07,6.07-15.91,6.07-21.98,0s-6.07-15.91,0-21.98 S340.47,318.69,346.54,324.76z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M338.75,378.35c-10.98,0-22.15-4.31-30.56-12.73L166.6,224.03c-31.37,9.98-66.02,1.73-89.31-21.56 c-20.49-20.49-29.62-49.75-24.43-78.29c0.42-2.31,2.08-4.19,4.32-4.89c2.23-0.7,4.68-0.1,6.33,1.56l33.46,33.46l19.04,9.59 l47.7-47.7l-9.59-19.04L120.65,63.7c-1.66-1.66-2.26-4.1-1.56-6.33c0.7-2.24,2.58-3.9,4.89-4.32c28.53-5.19,57.8,3.95,78.29,24.43 c23.29,23.29,31.54,57.95,21.56,89.31l142.85,142.85c8.07,8.07,12.39,19.2,11.85,30.54c-0.55,11.52-5.81,21.96-14.82,29.4 C356.59,375.46,347.73,378.35,338.75,378.35z M168.27,210.5c1.64,0,3.25,0.64,4.46,1.85L317.1,356.71 c10.76,10.76,27.71,12.14,38.6,3.15c6.24-5.15,9.88-12.35,10.26-20.28c0.37-7.8-2.61-15.47-8.17-21.03L212.15,172.92 c-1.74-1.74-2.31-4.33-1.45-6.64c10.26-27.75,3.45-59.11-17.33-79.9c-14.52-14.51-34.2-22.4-54.37-22.17l24.74,24.74 c0.47,0.47,0.87,1.02,1.17,1.62L177,114.6c1.22,2.43,0.75,5.37-1.17,7.29l-54.14,54.14c-1.92,1.92-4.86,2.39-7.29,1.17L90.39,165.1 c-0.6-0.3-1.15-0.7-1.62-1.17l-24.74-24.74c-0.22,20.2,7.65,39.85,22.17,54.37c20.78,20.78,52.15,27.59,79.9,17.33 C166.8,210.62,167.54,210.5,168.27,210.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolIcon);
export default __webpack_public_path__ + "static/media/tool-icon.216b2fc9be0715a1a28cd8672d7a6584.svg";
export { ForwardRef as ReactComponent };